/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Status_SubmittedInputs */

const en_claim_status_submitted = /** @type {(inputs: Claim_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket opened`)
};

/**
* | output |
* | --- |
* | "Ticket opened" |
*
* @param {Claim_Status_SubmittedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_status_submitted = /** @type {((inputs?: Claim_Status_SubmittedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Status_SubmittedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_status_submitted(inputs)
});